import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../../_services/data.service';

@Pipe({
  name: 'inrFormat'
})
export class InrFormatPipe implements PipeTransform {

  constructor(private dataService: DataService) {
  }

  transform(value: any, args?: any): any {
    return this.dataService.formatNumberAsINR(value || 0);
  }

}
